export default "/brand/_assets/images/loader.gif";